import { SET_DISCONNECT_WALLET, SET_WALLET, SET_NAME, SET_CONNECTED, SET_TOKEN_BALANCE } from "../constants";
import storage from "../../helpers/storage";

// Actions
// wallet and wallet name are saved to restore the session after a reload (helpers/session.js)
// only addresses are kept, wallet SDK objects belong to the session (hooks/useWallet.jsx)
const serializableWallet = (wallet) =>
  Array.isArray(wallet) ? wallet.map((account) => ({ address: account.address, name: account.name })) : wallet;

export const setWallet = (data) => {
  data = serializableWallet(data);
  storage.setItemDevice("wallet", JSON.stringify(data));
  return {
    type: SET_WALLET,
    payload: data,
  };
};

export const setWalletName = (data) => {
  storage.setItemDevice("wallet_name", JSON.stringify(data));
  return {
    type: SET_NAME,
    payload: data,
  };
};

export const setConnected = (data) => ({
  type: SET_CONNECTED,
  payload: data,
});

export const setTokenBalance = (contract, value) => ({
  type: SET_TOKEN_BALANCE,
  payload: {
    contract: contract,
    value: value,
  },
});

export const disconnectWallet = () => {
  storage.removeItemDevice("wallet");
  storage.removeItemDevice("wallet_name");
  return {
    type: SET_DISCONNECT_WALLET,
  };
};
